import type { CSSProperties } from "react";
import { useTheme } from "@repo/tokens";

export const useFlippableMemoryCardStyles = () => {
  const { theme } = useTheme();

  return {
    accentText: {
      color: theme.colors.neutral[10],
    } satisfies CSSProperties,
  };
};
